import React, { useState } from 'react';
import { Row, Col, Card, Select, Input, Tabs } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import CreativeCTRTable from './CreativeCTRTable';
import CreativeRingChart from './CreativeRingChart';
import { prepareCTR } from '../../../../../../../core/utils/campaigns';
// Global Styling
import {
  CardTitleText,
  MenuItemText,
  TableColumnTitle,
} from '../../../../../../shared/globalStyling/styledText';
//colors
import { colors } from '../../../../../../../core/utils/constants/listOfColors';

const { Option } = Select;
const Style = {
  campaignCardStyle: {
    margin: 5,
    padding: 2,
    height: 340,
    backgroundColor: '#fff',
  },
  campaignCardStyleCreatives: {
    backgroundColor: '#fff',
  },
  keyColors: {
    spent: '#1665d8',
    remaining: '#34aa44',
    budget: '#030303',
    total: '#bec0c3',
    value: '#99999',
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 24,
    offset: 0,
  },
  md: {
    span: 16,
    offset: 0,
  },
  lg: {
    span: 16,
    offset: 0,
  },
  xl: {
    span: 16,
    offset: 0,
  },
  xsPie: {
    span: 24,
    offset: 0,
  },
  smPie: {
    span: 24,
    offset: 0,
  },
  mdPie: {
    span: 8,
    offset: 0,
  },
  lgPie: {
    span: 8,
    offset: 0,
  },
  xlPie: {
    span: 8,
    offset: 0,
  },
};

const {
  xs,
  sm,
  md,
  lg,
  xl,
  xsPie,
  smPie,
  mdPie,
  lgPie,
  xlPie,
  keyColors,
  campaignCardStyle,
  campaignCardStyleCreatives,
} = Style;

const options = [
  {
    value: 'impressions',
    text: 'Impressions',
  },
  {
    value: 'CTR',
    text: 'CTR Percentage',
  },
  {
    value: 'clicks',
    text: 'Clicks',
  },
];

const Extra = ({ setCreativeDimension }) => {
  return (
    <Row align="bottom">
      <TableColumnTitle text={'Show By:'} />
      <Select
        defaultValue={options[0].value}
        onChange={(value) => {
          setCreativeDimension(value);
        }}
      >
        {options.map((option, index) => {
          return (
            <Option key={index} value={option.value}>
              <MenuItemText text={option.text} />
            </Option>
          );
        })}
      </Select>
    </Row>
  );
};

const CreativeDetails = (props) => {
  const { selectedCreativeDimension, setCreativeDimension, creativeData } = props;

  const [searchValue, setSearchValue] = useState('');
  const [activeTab, setActiveTab] = useState('active');

  const parsedData = prepareCTR(creativeData);
  const colorValuePairs = parsedData.map((el, index) => {
    if (el.xAxis) {
      return {
        ...el,
        value: el.xAxis,
        color: colors[index],
      };
    } else if (el.value) {
      return {
        ...el,
        color: colors[index],
      };
    }
    return {
      ...el,
      value: `Creative ${index}`,
      color: colors[index],
    };
  });

  const isCreativeActive = (creative) => {
    return creative.activity === 'active';
  };
  const tabFilteredData = colorValuePairs.filter((creative) => {
    if (activeTab === 'all') return true;
    if (activeTab === 'active') return isCreativeActive(creative);
    if (activeTab === 'inactive') return !isCreativeActive(creative);
    return true;
  });

  // Filter by search value
  const filteredData = tabFilteredData.filter((item) =>
    String(item.value ?? '')
      .toLowerCase()
      .includes(searchValue.toLowerCase())
  );

  const tabItems = [
    {
      key: 'all',
      label: 'All',
      children: null,
    },
    {
      key: 'active',
      label: 'Active',
      children: null,
    },
    {
      key: 'inactive',
      label: 'Inactive',
      children: null,
    },
  ];

  return (
    <Row gutter={35}>
      <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
        <Card
          style={campaignCardStyleCreatives}
          headStyle={{ borderWidth: '3px' }}
          bodyStyle={{ padding: 0 }}
          title={<CardTitleText text={'Creatives'} />}
          extra={
            <Input
              placeholder="Search Creatives..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              style={{ width: '100%' }}
              addonBefore={<SearchOutlined />}
            />
          }
        >
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            items={tabItems}
            style={{ marginBottom: 0 }}
            tabBarStyle={{ paddingLeft: '16px', paddingRight: '16px', marginBottom: 0 }}
          />
          <CreativeCTRTable creativeData={filteredData} />
        </Card>
      </Col>
      <Col xs={xsPie} sm={smPie} md={mdPie} lg={lgPie} xl={xlPie}>
        <Card
          style={campaignCardStyleCreatives}
          bodyStyle={{ padding: 0, height: '100%' }}
          headStyle={{ borderWidth: '2px' }}
          title={<CardTitleText text={'Breakdown'} />}
          extra={<Extra setCreativeDimension={setCreativeDimension} />}
        >
          <CreativeRingChart
            data={filteredData}
            keyColors={keyColors}
            height={campaignCardStyle.height}
            selectedCreativeDimension={selectedCreativeDimension}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default CreativeDetails;
